import { render } from "./MenuModal.vue?vue&type=template&id=ccd97736&scoped=true"
import script from "./MenuModal.vue?vue&type=script&lang=js"
export * from "./MenuModal.vue?vue&type=script&lang=js"

import "./MenuModal.vue?vue&type=style&index=0&id=ccd97736&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccd97736"]])

export default __exports__